export const OR4_PDP_SESSION_STORAGE_KEY = 'Or4PDPState';
